import {Component} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-mno-detail',
  templateUrl: './mno-detail.component.html'
})
export class MnoDetailComponent extends BaseComponent {
  mno:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/np/mnos/${id}`).subscribe(
            data => {
              this.setMno(data)
            }
          );
        }
      });
  }

  setMno(mno:any) {
    this.mno = mno;
  }

  createNew() {
    this.mno = {
      editable: true
    };
  }

  save() {
    if (!this.mno.id) {
      this.http.post(`${this.env.e.url}/np/mnos`, this.mno)
        .subscribe(
          data => {
            this.setMno(data)
            this.alertService.info(`Created ${this.mno.name}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/np/mnos/${this.mno.id}`, this.mno)
        .subscribe(
          data => {
            this.setMno(data)
            this.alertService.info(`Updated`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/np/mnos/${this.mno.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted ${this.mno.name}`);
          this.router.navigate(["/mnos"]);
        }
      );
  }

  hasRole(role:string) {
    if (!role) {
      return true;
    }
    return this.authService.hasRole(role);
  }
}
